import { render, staticRenderFns } from "./PanicButton.vue?vue&type=template&id=658d4698&scoped=true&"
import script from "./PanicButton.vue?vue&type=script&lang=js&"
export * from "./PanicButton.vue?vue&type=script&lang=js&"
import style0 from "./PanicButton.vue?vue&type=style&index=0&id=658d4698&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658d4698",
  null
  
)

export default component.exports